import React from "react";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneNumberInput = ({ defaultValue, name }) => {
  const form = useFormInstance();
  return (
    <div className="relative">
      <PhoneInput
        country={"us"}
        inputClass={"!h-11 !w-full !rounded-lg"}
        containerClass={
          "!rounded-lg border hover:border-blue-400 focus:border-blue-400"
        }
        placeholder="Phone Number"
        buttonClass="!rounded-l-lg"
        value={defaultValue}
        onlyCountries={['us']}
        onChange={(e) => {
          form.setFieldValue(name,e);
        }}
      />
    </div>
  );
};

export default PhoneNumberInput;
